import { DocSection, kbd } from '../../../pages/shell';
import { DocShot } from '../../DocShot';
import { Link } from 'react-router-dom';

export const toc = [
  { id: 'overview', label: 'Overview' },
  { id: 'transcription', label: 'How transcription works' },
  { id: 'how-search-works', label: 'How search works' },
  { id: 'languages', label: 'Languages' },
  { id: 'transcript-viewer', label: 'The transcript viewer' },
  { id: 'speech-problems', label: "When speech can't be analyzed" },
];

export default function Body() {
  return (
    <>
      <DocSection id="overview" title="Overview">
        <p>
          Quote the exact words someone said and <span style={kbd}>Speech</span> mode jumps straight to
          that moment — no scrubbing through footage listening for it. Every match shows the transcript
          line it came from and its timecode, right in the result card.
        </p>
        <DocShot slug="speech-search" shot="result" alt="Speech-mode result with transcript line and timecode" caption="A Speech result: the matching line, in context, with its timecode." />
      </DocSection>
      <DocSection id="transcription" title="How transcription works">
        <p>
          The Speech pass transcribes each source once, on your GPU, using faster-whisper. The result is
          a per-source transcript that Speech mode searches — you never wait for transcription at search
          time. The transcript is the spoken words in order, each with a timecode; ClipRadar doesn't
          label who said what.
        </p>
      </DocSection>
      <DocSection id="how-search-works" title="How search works">
        <p>
          Speech mode is full-text search over your transcripts — a keyword lookup (SQLite FTS5, ranked
          by BM25) blended with a semantic layer, so near-matches and paraphrases can surface too, not
          just exact wording.
        </p>
      </DocSection>
      <DocSection id="languages" title="Languages">
        <p>
          Language is detected automatically per file — you don't set it before analyzing. The underlying
          model is broadly multilingual, so transcription isn't limited to English.
        </p>
      </DocSection>
      <DocSection id="transcript-viewer" title="The transcript viewer">
        <p>
          Open the full transcript from a result card (<span style={kbd}>Show transcript</span>), a Media
          row (<span style={kbd}>View Transcript</span>), or a speech-problem popover — it scrolls
          straight to the matched line and highlights the phrase you searched for. Select one or more
          lines to <span style={kbd}>Add to timeline</span> or <span style={kbd}>Export SRT</span>, and
          adjust the in/out point inline before you do.
        </p>
        <DocShot slug="speech-search" shot="transcript" alt="Transcript panel with a highlighted phrase" caption="The transcript viewer, scrolled to a matched line." />
      </DocSection>
      <DocSection id="speech-problems" title="When speech can't be analyzed">
        <p>
          Some files have audio ClipRadar can't read — a damaged track, no audio at all, or audio that
          decodes but sounds wrong. When that happens the source is honestly marked "speech not
          analyzed" rather than silently failing, and ClipRadar retries with a bounded rescue pass before
          giving up. See <Link to="/docs/guides/fix-speech-problems">Fix speech &amp; transcript problems</Link> for
          how to read the badge and what to do about it.
        </p>
      </DocSection>
    </>
  );
}
